import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../../../models/api-url.model';
import { Invoice } from '../../../models/invoice.model';
import { Payment } from '../../../models/payment.model';
import { ApiService } from '../api';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  private readonly apiService = inject(ApiService);

  getPayments(): Observable<Payment[]> {
    return this.apiService.get(api.paymentsURL);
  }

  getInvoices(): Observable<Invoice[]> {
    return this.apiService.get(api.invoicesURL);
  }
}
